import { usePendingProductContract } from "@/api/services/admin/product-contract";
import { LoadingPage } from "@/modules/irohana-components/elements/Loading/Loading";
import { OrganizationForm } from "@/features/organization/components/OrganizationForm";
import { AppRoutes } from "@/routes/config";
import Cookies from "js-cookie";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

/**
 * 組織新規登録. Reached after a center SSO handoff (see AuthCallback), which stashes a
 * `contract-token` cookie. We resolve the staged pending product contract to obtain the
 * center `organizationId` + `productContractId` required by the create API, then render
 * the shared OrganizationForm in create mode.
 */
const OrganizationCreate = () => {
  const navigate = useNavigate();
  const token = Cookies.get("contract-token");

  const { data, isLoading, isError } = usePendingProductContract(token);

  const pending = data?.data?.data ?? null;

  useEffect(() => {
    if (!token) {
      navigate(AppRoutes.organizationList, { replace: true });
    }
  }, [token, navigate]);

  useEffect(() => {
    if (token && !isLoading && (isError || !pending)) {
      navigate(AppRoutes.organizationList, { replace: true });
    }
  }, [token, isLoading, isError, pending, navigate]);

  if (!token || isLoading || !pending) return <LoadingPage />;

  return (
    <OrganizationForm
      backUrl={AppRoutes.organizationList}
      centerOrganizationId={pending.organizationId}
      productContractId={pending.productContractId}
    />
  );
};

export default OrganizationCreate;
